import React, { useState, useEffect } from "react";
import axios from "axios";
import { getsessionuser } from "../Utils/sessions";
import { Alert, Button, Checkbox, Container, Snackbar, TextField } from "@mui/material";
import { AddCircle, Delete, Save, Send } from "@mui/icons-material";
import { primarycolor } from "../Utils/colors";
import Loadingspinner from "../Components/loading";
import { Updatereviewurl } from "../Utils/urls";



const Reviews = ({ onsuccessreview, reviews, id }) => {


    const user = getsessionuser()
    const [error, setError] = useState(null);
    const [success, setsuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const [review, setreview] = useState('');

    var currentdate = new Date();

    var time = currentdate.getHours() + ":" + currentdate.getMinutes();
    var date = currentdate.getDate() + "/" + (currentdate.getMonth() + 1) + "/" + currentdate.getFullYear();



    const submit = () => {
        setLoading(true)
        const message = {
            review: review,
            name: user.username,
            time: time,
            date
        }

        if (Array.isArray(reviews)) {

            var index = reviews.findIndex(obj => obj?.name == user.username);
            if (index !== -1) {
                setError("You cannot comment more than once")
                setLoading(false)
            } else {
                reviews.push(message);
                axios.post(Updatereviewurl, {
                    id: id,
                    reviews: reviews
                }).then(function (response) {
                    if (!response.data.error) {
                        setsuccess("Review sent")
                        setTimeout(() => {
                            onsuccessreview()
                        }, 3000);
                    } else {
                        setError(response.data.message)
                    }
                    // 
                }).catch(function (error) {
                    setLoading(false)
                    setError("There was an error try again later")
                });
            }
        } else {
            const finalreview = [message];
            axios.post(Updatereviewurl, {
                id: id,
                reviews: finalreview
            }).then(function (response) {
                if (!response.data.error) {
                    setsuccess("Review sent")
                    setTimeout(() => {
                        onsuccessreview()
                    }, 3000);
                } else {
                    setError(response.data.message)
                }
                // 
            }).catch(function (error) {
                setLoading(false)
                setError("There was an error try again later")
            });
        }
    }


    const textinputstyles = {
        maxHeight: 20,
        marginRight: 5,
        width: "100%",
        marginBottom: 5,
        fontSize: 10
    }



    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 5,
            borderRadius: 2
        }} maxWidth="sm">
            {loading && <Loadingspinner />}
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => setError()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            <div className="overflowdivwithoutscroll">
                {Array.isArray(reviews) && reviews.map((val, key) => {

                    return (
                        <div className="reviewchild">
                            <div className="reviewtext">{val.review}</div>
                            <div className="reviewname">{val.time} {val.date} by {val.name}</div>
                        </div>
                    )
                })}
                <br />
                <div className="right2">
                    Send a review<br />
                    <textarea rows="4" cols="50" style={{ resize: "none" }} name="review" form="usrform" value={review} onChange={(e) => setreview(e.target.value)}>
                        Enter your review ...
                    </textarea>
                </div>

                <div className="bottom2">
                    {error && <div className="error">{error}</div>}
                    <Button variant="outlined" disabled={!user && true} startIcon={<Send />} onClick={submit}>
                        Submit
                    </Button><br />
                </div>

            </div>
        </Container>
    );
}

export default Reviews;